import {NotFound} from "../interface/not-found";

export class NotFoundStructure {
	private static readonly _NotFound: NotFound = {
		image: 'https://images.unsplash.com/photo-1551488831-00ddcb6c6bd3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80',
		buttonText: 'Let Us Redirect You',
		link: '',
		heading: 'Oops..!!',
		paragraph: 'Looks like this is a wrong closet',
	}
	public static get methNotfound(): NotFound {
		return NotFoundStructure._NotFound
	}
}
